import {Button} from '@progress/kendo-react-buttons'
import React from 'react'
import {connect} from 'react-redux'
import {Col, Container, Row} from 'reactstrap'
import {FlashMessage} from '../../components/flash-message'
import {Loading} from '../../components/loading'
import {RasaMenu} from '../../components/menu'
import * as Actions from './actions'
import * as Types from './types'

interface StateProps extends Types.IsValidating {
  fields: Types.FieldPayload,
}
interface DispatchProps {
  updateLoginField: Types.UpdateFieldFn,
  login: Types.LoginSubmit,
}
type Props = StateProps & DispatchProps
export const LoginPagePure = (props: Props) => <div>
  <RasaMenu />
  <Container>
    <Row>
      <Col sm="12" md={{offset: 4, size: 4}}>
        <h1>Login</h1>
        <FlashMessage />
        <form className="k-form" onSubmit={(e) => {
          e.preventDefault()
          if (!props.isValidating) {props.login(props.fields)}
        }}>
          <label className="k-form-field">
              <span>Email</span>
              <input
                className="k-textbox"
                placeholder="Email"
                onChange={(e) => props.updateLoginField({name: 'email', value: e.target.value})}
              />
          </label>
          <label className="k-form-field">
              <span>Password</span>
              <input
                type="password"
                className="k-textbox"
                placeholder="Your Password"
                onChange={(e) => props.updateLoginField({name: 'password', value: e.target.value})}
              />
          </label>
          {props.isValidating ?
            <Loading size={Loading.Sizes.SMALL} /> :
            <Button primary={true} type="submit">Login</Button>
          }
        </form>
      </Col>
    </Row>
  </Container>
</div>

export const LoginPage = connect(
  ({loginForm}: Types.WrappedState) => ({fields: loginForm.fields, isValidating: loginForm.ui.isValidating}),
  {updateLoginField: Actions.updateLoginField, login: Actions.loginSubmit},
)(LoginPagePure)



// WEBPACK FOOTER //
// ./src/pages/login/component.tsx